import { Carousel } from '@carvana/helios-layout';
import RatingStars from '@carvana/stc-rating-stars';

import useAnalyticEvent from '../../shared/hooks/useAnalyticEvent';
import { CarouselEventData } from '../../analytics/uiMetrics';
import useCustomerReviews from '../../shared/hooks/useCustomerReviews';
import {
  Background,
  Container,
  Info,
  ReviewContainer,
  Link,
  Title,
  StarContainer,
  TotalRating
} from './CustomerReviews.styles';
import ReviewCard from './Review';

const CustomerReviews = () => {
  const { recordActionClicked, recordEventAndNavigate } = useAnalyticEvent();
  const { data: reviews } = useCustomerReviews();

  const handleSeeReviewsClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    recordEventAndNavigate(e, 'Landing Page', 'See all reviews');
  };

  const recordCarouselEvents = (data: CarouselEventData) => {
    recordActionClicked('Landing Page', 'Review carousel navigate', data);
  };

  return (
    <Background>
      <Container>
        {reviews && (
          <Carousel
            carouselHeaderComponent={
              <>
                <Title>What Our Customers Are Saying</Title>
                <StarContainer>
                  <RatingStars rating={5} />
                </StarContainer>
                <TotalRating>4.8 Stars</TotalRating>
                <Info>
                  We've purchased more than 1 million cars from customers and received a lot of
                  great feedback. See what’s behind our 4.8 star average rating.
                  <Link href="/reviews" onClick={handleSeeReviewsClick}>
                    See All Reviews
                  </Link>
                </Info>
              </>
            }
            carouselAriaLabel="customer-reviews"
            trackEvent={recordCarouselEvents}
          >
            {reviews.map(({ attributes: review }) => (
              <ReviewContainer key={review.blurb}>
                <ReviewCard review={review} />
              </ReviewContainer>
            ))}
          </Carousel>
        )}
      </Container>
    </Background>
  );
};

export default CustomerReviews;
